//api path 
const subscribersSendVerificationMail = window.customerData?.mobileApiEntryPoint ? (window.customerData?.mobileApiEntryPoint + "/subscribers/send-verification-mail") : null;
const subscribersVerifyEmail = window.customerData?.mobileApiEntryPoint ? (window.customerData?.mobileApiEntryPoint + "/subscribers/verify-email") : null;

const codeInputs = document.querySelectorAll('.code-input');
const verify_email = document.getElementById('verify_email');
const errorElement = document.getElementById('errorEmailverifyOtp');
const successElement = document.getElementById('successEmailVerifyOTP');

//  Open Popup
function openEmailVerifyPopup() {
  const popup = document.getElementById('email_verify_popup');
  if(window.location.href.includes('account')){
    document.getElementById('before_continue_verify').classList.add('hidden')
  }
  if (popup) {
    popup.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }
}

// Handle Resend Click
let otpNextGenerationAt = 0;
let timerInterval = null;

async function handleResendClick() {
  const now = Date.now();

  if (now < otpNextGenerationAt) {
    console.log("⏳ Please wait before resending.");
    return;
  }

  const result = await generateEmailVerifyOtp();

  if (result?.otpNextGenerationAt) {
    otpNextGenerationAt = result.otpNextGenerationAt;
    startCooldownTimer(otpNextGenerationAt);
  }
}

async function generateEmailVerifyOtp() {
  codeInputs.forEach(input => input.value = '');

  const errorElement = document.getElementById('errorEmailverifyOtp');
  const successElement = document.getElementById('successEmailVerifyOTP');

  try {

    const formData = new FormData();
    const gbToken = await updateGBToken();
    const response = await fetch(subscribersSendVerificationMail, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${gbToken}`,
      },
      body: formData,
    });

    // Hide success initially
    successElement.textContent = '';
    successElement.classList.add('hidden');

    // Handle non-200 responses
    if (!response.ok) {
      errorElement.classList.remove('hidden');
      const errorData = await response.json();
      errorElement.textContent = errorData.message;
      // Optional: disable resend button here
      return;
    }

    // Success
    const result = await response.json();

    errorElement.textContent = '';
    errorElement.classList.add('hidden');

    successElement.textContent = result.message || 'OTP sent successfully!';
    successElement.classList.remove('hidden');

    setTimeout(() => successElement.classList.add('hidden'), 5000);

    return result;

  } catch (error) {
    console.log('Error generating OTP:', error);

    successElement.textContent = '';
    successElement.classList.add('hidden');

    errorElement.textContent = error.message || 'Something went wrong. Please try again.';
    errorElement.classList.remove('hidden');

    return null;
  }
}

function startCooldownTimer(unixTimestampMs) {
  const resendLink = document.getElementById('resendLink');
  const resendTimer = document.getElementById('resendTimer');

  // Disable resend link
  resendLink.style.pointerEvents = 'none';
  resendLink.style.opacity = 0.5;

  // Clear any previous interval
  if (timerInterval) clearInterval(timerInterval);

  timerInterval = setInterval(() => {
    const now = Date.now();
    const remaining = Math.ceil((unixTimestampMs - now) / 1000);

    if (remaining <= 0) {
      clearInterval(timerInterval);
      resendTimer.textContent = ''; // Clear the timer text
      resendLink.style.pointerEvents = 'auto';
      resendLink.style.opacity = 1;
    } else {
      resendTimer.textContent = `(${remaining}s)`;
    }
  }, 1000);
}


if (verify_email) {
  verify_email.addEventListener('click', async (event) => {
    event.preventDefault(); // Prevent default form submission

    const codeInputs = document.querySelectorAll('.code-input');
    const otp = Array.from(codeInputs).map(input => input.value).join('');

    const email_verif_pop_up = document.getElementById('email_verif_pop_up');
    const emailVerifiedSuccessMsg = document.getElementById('email_verifed_success_msg');
    // const success_checkmark = document.getElementById('success_checkmark');

    const email_warning_msg = document.getElementById('email_warning_msg');
    const warning_checkmark = document.getElementById('warning_checkmark');
    const email_warning_btn = document.getElementById('email_warning_btn');

    const errorElement = document.getElementById('errorEmailverifyOtp');
    const successElement = document.getElementById('successEmailVerifyOTP');

    if (errorElement) errorElement.textContent = '';
    if (successElement) successElement.textContent = '';
    if (errorElement) errorElement.classList.add('hidden');
    if (successElement) successElement.classList.add('hidden');

    // Validation
    if (!otp) {
      if (errorElement) {
        // errorElement.textContent = 'Please enter the verification code.';
        errorElement.classList.remove('hidden');
      }
      return;
    }

    if (otp.length < 6) {
      if (errorElement) {
        // errorElement.textContent = 'Please enter a complete 6-digit verification code.';
        errorElement.classList.remove('hidden');
      }
      return;
    }

    try {
      const gbToken = await updateGBToken();
      const response = await fetch(subscribersVerifyEmail, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${gbToken}`,
        },
        body: JSON.stringify({ otp }),
      });

      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        const errorMsg = result.message || `Verification failed (status: ${response.status})`;
        throw new Error(errorMsg);
      }

      const result = await response.json();

      if (successElement) {
        // successElement.textContent = result.message || 'Email verified successfully!';
        successElement.classList.remove('hidden');
        const popup = document.getElementById('email_verify_popup');
        if (popup) {
          popup.classList.add('active_email_verified_success');
        }
      }

      if (email_warning_msg) email_warning_msg.classList.add('hidden');
      if (warning_checkmark) warning_checkmark.classList.add('hidden');
      if (email_warning_btn) email_warning_btn.classList.add('hidden');
      if (email_verif_pop_up) email_verif_pop_up.classList.add('hidden');
      //show the success popup and remove otp section
      document.getElementById('email_varification_pop_up').classList.add('hidden')
      document.getElementById('email_verified_success').classList.remove('hidden')

      // if (success_checkmark) success_checkmark.classList.remove('hidden');
      // if (emailVerifiedSuccessMsg) {
      //   emailVerifiedSuccessMsg.classList.remove('hidden');
      //   emailVerifiedSuccessMsg.textContent = result.message;
      // }

      // closeEmailVerifyPopup();

      const subscriber = await subscriberMe();
      console.log("window.subscriberMeResponse", subscriber);

      const verifyedEmail = document.getElementById('verified_email');
      const verifyEmail = document.getElementById('verify_email');

      if (subscriber && subscriber.verifiedAccount === true) {
        if (verifyEmail) verifyEmail.classList.add('hidden');
        if (verifyedEmail) verifyedEmail.classList.remove('hidden');
        console.log("Email is verified, showing verified message.");
      } else {
        if (verifyEmail) verifyEmail.classList.remove('hidden');
        // if (verifyedEmail) verifyedEmail.classList.add('hidden'); // optional
        console.log("Email is not verified, showing verify button.");
      }
      //if user in plan collection page
      if (window.location.href.includes('collections')) {
        canProceedToCheckout();
      }

      // setTimeout(() => {
      //   closeEmailVerifyPopup();
      //   
      // }, 3000);

    } catch (error) {
      console.error('Error verifying email:', error.message);
      if (errorElement) {
        errorElement.textContent = error.message ;
        errorElement.classList.remove('hidden');
      }
    }
  });
}

// close 

function closeEmailVerifyPopup() {
  const popup = document.getElementById('email_verify_popup');
  if (popup) {
    popup.classList.add('hidden');
    document.body.style.overflow = '';
    errorElement.textContent = '';
    successElement.textContent = '';
    errorElement.classList.add('hidden');
    successElement.classList.add('hidden');
    codeInputs.forEach(input => input.value = '');

  }
}
